export default __webpack_public_path__ + "static/young-toddler8-dc0344a750556e08bd189d0bf440273a.jpg";